<!-- Magnifier pointer: click to zoom in, Shift/Alt-click to zoom out, Ctrl/Cmd + wheel
     or pinch to zoom; the wheel scrolls and dragging moves the page. -->
<div class="viewer-conteiner" appPanZoom scrollSelector=".ng2-pdf-viewer-container"
     (zoomStep)="zoomBy($event)" (zoomReset)="zoomReset()">
    <!-- Only while zoomed: back to the size the document opened at. -->
    <button type="button" class="zoom-reset" *ngIf="pdfZoom !== defaultZoom" (click)="resetZoom()"
            title="Back to the original size">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>
        <span class="zoom-reset__level">{{ pageScale }}%</span>
        <span>Reset</span>
    </button>
    <pdf-viewer class="viewer" 
            [src]="tempFile" 
            [render-text]="false"
            [original-size]="false" 
            [show-all]="true"
            [zoom]="pdfZoom" 
            [fit-to-page]="true" 
            [autoresize] = true
            (after-load-complete)="afterLoadComplete($event)"
            (error)="loadError.emit($event)">
    </pdf-viewer>
</div>
